export default __webpack_public_path__ + "d8e2e5153c5968407b645ce100358b31.png";